import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input, Select, Button } from "antd";
import moment from "moment";
import { strings } from "../../helpers";

const { Search } = Input;
const { Option } = Select;

export default class PromoCodeListView extends Component {
  render() {
    const {
      promoCodeList,
      allRecords,
      pageNo,
      onPageChange,

      navigateToUsersDetails,
      toggleAddModal,
      deletePromoCode,
      openEditPromoCodeModal
    } = this.props;

    const columns = [
      {
        title: "Promo Code name",
        key: "promo_code_name",
        align: "left",
        render: record => (
          <a onClick={e => openEditPromoCodeModal(e, record)}>
            {" "}
            {record.promo_code_name || "--"}
          </a>
        )
      },
      {
        title: "Single Use",
        key: "single_use",
        align: "left",
        render: record => (
          <div>{record.single_use === true ? "Yes" : "No" || "--"}</div>
        )
      },
      {
        title: "Expire By",
        key: "expiry",
        align: "left",
        render: record => (
          <div>{moment(record.expiry).format("DD-MM-YYYY") || "--"}</div>
        )
      },
      {
        title: "Created At",
        key: "created_at",
        align: "left",
        render: record => (
          <div>{moment(record.created_at).format("DD-MM-YYYY") || "--"}</div>
        )
      },
      {
        title: "Discount",
        align: "left",
        render: record => (
          <div>
            {record && record.discount_percentage && (
              <div>{`${record.discount_percentage} %`}</div>
            )}
            {record && record.discount_amount && (
              <div>{`₹ ${record.discount_amount}`}</div>
            )}
          </div>
        )
      },
      {
        align: "left",
        render: record => (
          <div>
            {
              <Button
                type="default"
                shape="circle"
                icon="delete"
                onClick={() =>
                  deletePromoCode(record.promo_code_name, record.id)
                }
              />
            }
          </div>
        )
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={12} className="heading-domain">
              Billing Promo Codes
            </Col>
            <Col span={2} className="text-right">
              <Button
                type="primary"
                shape="circle"
                icon="plus"
                onClick={() => toggleAddModal()}
              />
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={promoCodeList}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
        <div className="pagination-wrapper">
          {allRecords > 10 && (
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
          )}
          {allRecords > 10 && (
            <Pagination
              total={allRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={10}
              defaultCurrent={pageNo}
            />
          )}
        </div>
      </div>
    );
  }
}
